// packages/shared/src/mail.ts
import { z } from "zod";

/**
 * Arten von Systemmails (#352). Eine Art ist die Einheit, von der man sich
 * abmeldet und für die ein Admin das Abmelden abschalten kann.
 */
export const MAIL_ARTEN = ["wochen_digest"] as const;
export const mailArtSchema = z.enum(MAIL_ARTEN);
export type MailArt = z.infer<typeof mailArtSchema>;

export const mailEinstellungSchema = z.object({
  art: mailArtSchema,
  /** Die eigene Abmeldung, wie gespeichert — auch wenn sie gerade nicht greift. */
  abgemeldet: z.boolean(),
  abmeldenErlaubt: z.boolean(),
});
export type MailEinstellung = z.infer<typeof mailEinstellungSchema>;

export const mailEinstellungenSchema = z.object({ items: z.array(mailEinstellungSchema) });
export type MailEinstellungen = z.infer<typeof mailEinstellungenSchema>;

export const mailAbmeldungSetzenSchema = z.object({ abgemeldet: z.boolean() });
export const mailArtSchalterSchema = z.object({ abmeldenErlaubt: z.boolean() });
